var render = function render(){var _vm=this,_c=_vm._self._c;return _c('XTextField',{attrs:{"label":_vm.label,"value":_vm.dataValue,"rules":_vm.computedRules,"tooltip":_vm.tooltip},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }